import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Badge, BottomNavigation, BottomNavigationAction, Box, Paper } from '@mui/material'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
// import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import CloseIcon from '@mui/icons-material/Close'
import MinimizeIcon from '@mui/icons-material/Minimize'
import MaximizeIcon from '@mui/icons-material/Maximize'
import useOnlineStatus from '../../hooks/useOnlineStatus'
import { useActionLogs } from '../../store/actionLogsContext'
import { canUserAccessActionHistory } from '../../pages/Statistics/statistics-report-type'
import { formatHistoryCountDisplay } from '../../utils/format-history-count'

/** Spazio sotto il contenuto per la bottom bar fissa (safe area inclusa). */
export const mobileBottomNavSpacerSx = {
  minHeight: 'calc(56px + env(safe-area-inset-bottom, 0px) + 16px)',
  flexShrink: 0,
  width: '100%',
}

export function MobileBottomNavSpacer () {
  return <Box sx={mobileBottomNavSpacerSx} aria-hidden />
}

export default function MobileBottomNav ({
  openDialog
  , openAdminDialog
  , onOpenAddCrash
  , handleFormOpen
  , isPositioning
  , isFormOpen
  , isPositionSet
  , cancelCrash
  , handlePositioningState
  , openMobileLayers
  , toggleMobileLayers
}) {
  const location = useLocation()
  const { state, state: { init } } = location
  const navigate = useNavigate()
  const { _ } = useLingui()
  const [value, setValue] = useState(0)
  const isOnline = useOnlineStatus()
  const navLockedOffline = !isOnline
  const { count: unreadCount } = useActionLogs()
  const canOpenNotifications = canUserAccessActionHistory(init?.user)

  return (
      <Box display='flex'>
      <Paper
        square
        elevation={3}
        sx={{
          position   : 'fixed'
          , bottom   : 0
          , left     : 0
          , right    : 0
          , zIndex   : theme => theme.zIndex.drawer + 1
          , height   : theme => theme.mixins.toolbar.minHeight
        }}>
          <BottomNavigation
            value={value}
            onChange={(_, newValue) => setValue(newValue)}
          >
          <BottomNavigationAction
            showLabel={false}
            label='Home'
            value='home'
            disabled={navLockedOffline}
            icon={<HomeOutlinedIcon />}
            onClick={() => {
              if (location.pathname === '/home') cancelCrash()
              else navigate('/home', { state })
              setValue(0)
            }}
          />
          {location.pathname === '/home' &&
            <>
              {/* <BottomNavigationAction
                label='Search'
                value='search'
                icon={<SearchOutlinedIcon />}
              /> */}
              <BottomNavigationAction
                  disabled={navLockedOffline || isPositioning || isFormOpen || isPositionSet}
                label='Overlays'
                value='overlays'
                icon={openMobileLayers ? <CloseIcon /> : <LayersOutlinedIcon />}
                onClick={() => {
                  toggleMobileLayers()
                }}
              />
              {canOpenNotifications &&
                <BottomNavigationAction
                  label={_(msg`Notifications`)}
                  value='notifications'
                  disabled={navLockedOffline}
                  icon={
                    <Badge color='error' badgeContent={unreadCount > 0 ? formatHistoryCountDisplay(unreadCount) : 0} max={Number.MAX_SAFE_INTEGER}>
                      <NotificationsNoneOutlinedIcon />
                    </Badge>
                  }
                  onClick={() => {
                    toggleMobileLayers(false)
                    navigate('/home', { state: { ...state, isHistoryOpen: true } })
                  }}
                />}
              <BottomNavigationAction
                label={isPositioning || isFormOpen
                  ? _(msg`Minimize`)
                  : isPositionSet
                    ? _(msg`Reopen`)
                    : _(msg`Add crash`)
                }
                value='addCrash'
                icon={isPositioning || isFormOpen
                  ? <MinimizeIcon />
                  : isPositionSet
                    ? <MaximizeIcon />
                    : <AddLocationOutlinedIcon />
                }
                onClick={() => {
                  toggleMobileLayers(false)
                  if (isPositioning || isFormOpen) {
                    handlePositioningState(false)
                    handleFormOpen(false)
                  } else if (isPositionSet) {
                    handleFormOpen(true)
                  } else if (typeof onOpenAddCrash === 'function') {
                    onOpenAddCrash()
                  } else if (init.user.type === 1) {
                    openAdminDialog()
                  } else {
                    openDialog()
                  }
                }}
              />
            </>}
          </BottomNavigation>
        </Paper>
      </Box>
  )
}

// , {
//   text: isPositioning || isFormOpen
//     ? t`Cancel`
//     : isPositionSet
//       ? t`Reopen`
//       : t`Add crash`
//   , icon: isPositioning || isFormOpen
//     ? <Close color='primary' />
//     : isPositionSet
//       ? <ArrowForwardIosIcon color='primary' />
//       : <AddLocationAltIcon color='primary' />
//   , type     : 'button'
//   , onMobile : false
//   , action   : isPositioning || isFormOpen
//     ? () => {
//         setIsPositionSet(false)
//         setIsFormOpen(false)
//         handlePositioningState(false)
//         const newMarkers = mapRef.current.getElementsByClassName('new-markers')
//         Array.from(newMarkers).forEach(marker => marker.remove())
//         methods.reset(initFormObj) // Resets form
//         setFormNumber(0)
//       }
//     : isPositionSet
//       ? () => setIsFormOpen(true)
//       : user.type === 1
//         ? openAdminDialog
//         : openDialog
// }
